export default "__VITE_ASSET__DkPx5lLO__"